import Vue from "vue";
import VueRouter from "vue-router";
import App from "@/App.vue";
import ViewerSearch from "@/components/ViewerSearch.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "hash",
  routes: [
    { path: "/", redirect: "/login" },
    { path: "/login", component: App },
    { path: "/chat", component: App, meta: { requiresAuth: true } },
    { path: "/viewer", component: ViewerSearch, meta: { requiresAuth: true } },
  ],
});

router.beforeEach((to, from, next) => {
  if (!to.meta.requiresAuth) return next();
  const token = localStorage.getItem("session_token");
  if (!token) {
    const loginQuery = {};
    if (to.query.ch) loginQuery.ch = to.query.ch;
    if (to.query.room) loginQuery.room = to.query.room;
    return next({ path: "/login", query: loginQuery });
  }
  next();
});

export default router;